// extracted by mini-css-extract-plugin
module.exports = {"badge":"BookedBadge_badge__1k-yT"};